<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
    .expand-row .ivu-row .ivu-col{
        color:#000!important;
    }
</style>
<template>
    <div>
        <div v-if="row.team_member_data.length > 0">
            <Row class="expand-row"  v-for="(item, index) in  row.team_member_data" :key="index" >
                <Col span="4" >
                    <span class="expand-key">{{item.name}}</span>
                </Col>
                <Col span="3">
                    <span class="expand-key">目标： </span>
                    <span class="expand-value">￥{{ item.target_money }}</span>
                </Col>
                <Col span="3">
                    <span class="expand-key">实际：</span>
                    <span class="expand-value">￥{{ item.actual_money }}</span>
                </Col>
                <Col span="3">
                    <span class="expand-key">差额：</span>
                    <span class="expand-value">￥{{ item.target_money  - item.actual_money }}</span>
                </Col>
                <Col span="3">
                    <span class="expand-key">完成度：</span>
                    <span class="expand-value">{{item.target_money == 0 ? 0 : ((item.actual_money / item.target_money ? item.actual_money / item.target_money : 0) * 100).toFixed(2)}}%</span>
                </Col>

            </Row>
        </div>

        <div v-else class="expand-row" >
            尚未分配队员
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
